import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Client from "../components/client/Client";
import { useLocation, useParams } from "react-router-dom";

// Clientpage component renders the client interface with a sidebar and client content.
// It receives an openDrawer prop to control the sidebar drawer and extracts route parameters and user data.
const Clientpage = ({ openDrawer }) => {
  // useParams hook provides access to route parameters (e.g., domainId in this case).
  const params = useParams();

  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // clientData object contains information specific to the client page, such as domain_id and UI state.
  const clientData = {
    domain_id: params.domainId, // Domain ID extracted from the route parameters
    isSearchFilterVisible: true, // Boolean flag to control the visibility of search filters
    dashboard: false, // Boolean flag to indicate whether the dashboard view is enabled
  };

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., client, admin)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (3 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={3} />

      {/* Client component that renders the main client content. It receives the openDrawer, userData, and clientData props. */}
      <Client
        openDrawer={openDrawer}
        userData={location.state}
        clientData={clientData}
      />
    </>
  );
};

export default Clientpage;
